import React from "react";
import MissionImg from "../../Images/Home/Mission.jpg";
import VisionImg from "../../Images/Home/vision.jpg";
import HomeBanner from "./HomeBanner";
import Help from "./Help";
import Causes from "./Causes";
import MVV from "./MVV";
import WhoWeAre from "./WhoWeAre";
import WhyND from "./WhyND";

const Home = () => {
  return (
    <>
      <HomeBanner />
      <WhoWeAre />
      <WhyND/>
      <MVV />
     
      <Causes />
    </>
  );
};

export default Home;
